import { Component, Host, h, Prop, Event, EventEmitter, Watch, forceUpdate } from '@stencil/core';
import {Logger} from "../../utils/logger";
import {IRequestField} from "../../interfaces/configuration";

@Component({
  tag: 'securecall-request-currency',
  styleUrl: 'securecall-request-currency.css',
  shadow: true,
})
export class SecurecallRequestCurrency {
  @Prop() fieldName: string;
  @Prop({ mutable: true }) config: IRequestField;

  @Event() isValidEvent: EventEmitter<{ field: string; valid: boolean, value: string }>;

  private readonly log = new Logger('SecurecallRequestCurrency')

  public get value(): string {
    return this.config.value;
  }
  public set value(value: string) {
    if (this.config.value !== value) {
      this.config.value = value;
      this.validateChange();
    }
  }

  @Watch('config')
  handleConfigChange(newConfig: any, oldConfig: any) {
    if(oldConfig.value !== newConfig.value) {
      this.value = newConfig.value;
      this.validateChange();
    } else if(oldConfig.valid !== newConfig.valid) {
      this.validateChange();
    }
  }

  componentWillLoad() {
    this.log.debug(this.fieldName + ": componentWillLoad: config", this.config);
    this.validateChange();
  }

  handleChange(ev) {
    this.log.debug("handleChange: string change:", ev.target.value);
    this.value = ev.target.value;
  }

  validateChange() {
    const input = this.value;
    const num = parseFloat(input);
    const isValidCurrency = /^(\d+(\.\d{1,2})?)?$/.test(input)
    const isValid = !isNaN(num) && num !== 0 && isValidCurrency
      && num >= (this.config.min || 0.01)
      && num <= (this.config.max || 99999.99);

    this.log.debug(this.fieldName + ": validateChange: string:", input, "isValid:", isValid, 'config.valid', this.config.valid);
    if(this.config.valid !== isValid) {
      this.config.valid = isValid;
      forceUpdate(this);
    }
    this.isValidEvent.emit({ field: this.fieldName, valid: isValid, value: input });
  }

  render() {
    return (
      <Host>
        <div class="field-container">
          <label class="custom-label" htmlFor={this.fieldName}>{this.config.label}:
          </label>
          <input
            type="text"
            class="custom-input"
            id={this.fieldName}
            placeholder={this.config.placeholder || this.config.label}
            value={this.value}
            disabled={this.config.readOnly}
            onInput={(ev) => this.handleChange(ev)}
          />
          <div class={this.config.valid ? 'field-valid' : 'field-invalid'}></div>
        </div>
      </Host>
    );
  }
}
